import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as CategoryList from 'types/_general/Store/AccessoryCategoryList';

const rb = new ReducerBuilder<CategoryList.Type>();

export const createAccessoryCategoriesLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'AccessoryCategories/LoadedFromBackend'
);

export const accessoryCategoriesReducer = rb.createReducer();
